import {createContext} from 'react';

import type {RegisterListener} from './types';

export const DndMonitorContext = createContext<RegisterListener | null>(null);



// WEBPACK FOOTER //
// ../src/components/DndMonitor/context.ts